/* global ga */
/*eslint no-console: ["error", { allow: ["info", "error"] }] */
import store from '@/store';
import vars from '@/config/vars';

let isInDevMode = vars.ENVIRONMENT === 'DEV';

export function initializeLogging(loggingToken) {
    if (isInDevMode)
        return;

    ga('create', loggingToken, 'auto');
}

export function logEvent(params) {
    let preorderId = store.state.preorder.Id || '[Sem PreorderId]';
    gaWrapper('send', {
        hitType: 'event',
        eventCategory: params.category,
        eventAction: params.action,
        eventLabel: `${params.label} | PreorderID: ${preorderId}`
    });
}

function gaWrapper(action, type) {
    if (isInDevMode && type == 'exception')
        return console.error('Google Analytics:', arguments);

    if (isInDevMode)
        return console.info('Google Analytics:', arguments);
    
    ga(...arguments);
}

export function logPageView(page) {
    gaWrapper('send', 'pageview', page);
}

export function logException(err) {
    let errorMessage = `[ERROR] ${(err) ? err.stack : 'Erro sem stack'}`;
    gaWrapper('send', 'exception', { exDescription: errorMessage });
}